import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function RequirePermission({ flag, module, action, children }) {
  const { can, hasFlag } = useAuth();
  const ok = flag ? hasFlag(flag) : can(module, action);
  if (!ok) {
    return (
      <div data-testid="access-denied" className="mx-auto mt-10 max-w-lg rounded-xl border border-slate-200 bg-white p-8 text-center">
        <ShieldAlert className="mx-auto mb-3 text-gold" size={36} />
        <h2 className="font-serif text-xl font-semibold text-navy">Access restricted</h2>
        <p className="mt-2 text-sm text-slate-600">
          You do not have permission to view this section. Please contact a practice administrator if you believe this is an error.
        </p>
      </div>
    );
  }
  return children;
}
